<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="rSrecord.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="rSrecord"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="建议人" prop="proposer">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="rSrecord.proposer" placeholder="请输入" readonly>
              <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectRSSuggestions.open()">选择建议人</el-button>
            </el-input>
            <r-s-suggestions-select ref="selectRSSuggestions" @select="selectRSSuggestions"/>
          </div>
        </el-form-item>
        <el-form-item label="建议人工号" prop="proposerNo">
          <el-input v-model="rSrecord.proposerNo" disabled placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="建议人部门" prop="department">
          <el-input v-model="rSrecord.department" disabled placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="标题" prop="proposalTitle">
          <el-input v-model="rSrecord.proposalTitle" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="建议描述" prop="proposalContent">
          <el-input v-model="rSrecord.proposalContent" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="建议类型" prop="proposalType">
          <el-select v-model="rSrecord.proposalType" clearable placeholder="请选择">
            <el-option
                v-for="item in proposalTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="图片">
          <vm-upload-file
              v-model="rSrecord.pictureUrl"
              filename.sync=""
              accept=".jpg,.png"/>
        </el-form-item>
        <el-form-item label="建议日期" prop="proposalTime">
          <el-date-picker
              v-model="rSrecord.proposalTime"
              align="right"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd HH:mm:ss"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import RSSuggestionsSelect from "@/views/information/RSSuggestions/RSSuggestionsSelect";
  import constant from "@/util/constant";
  import VmUploadFile from "@/components/VmUploadFile";
  export default {
    name:"RSRecordsEdit",
    components: {RSSuggestionsSelect,VmUploadFile},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        proposalTypes:constant.toSelect(constant.proposalTypes),
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        rSrecord: {
          pkid: "",
          rSId:"",
          proposer: "",
          proposerNo: "",
          department: "",
          proposalTitle: "",
          proposalContent: "",
          pictureUrl: "",
          proposalType: "",
          proposalTime: "",
        },
        ruleValidate: {
          proposer: {required: true, message: "建议人不能为空",trigger: "blur"},
          proposerNo: {required: true, message: "建议人工号不能为空",trigger: "blur"},
          department: {required: true, message: "建议人部门不能为空",trigger: "blur"},
          proposalTitle: {required: true, message: "标题不能为空",trigger: "blur"},
          proposalContent: {required: true, message: "建议描述不能为空",trigger: "blur"},
          proposalType: {required: true, message: "建议类型不能为空",trigger: "blur"},
          proposalTime: {required: true, message: "建议日期不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        //console.log(row);
        this.rSrecord.pkid = row.pkid;
        this.dialogVisible = true;
        if(this.rSrecord.pkid>0) {
          this.getData();
        }
      },
      selectRSSuggestions(row) {
        this.rSrecord.rSId = row.pkid;
        this.rSrecord.proposer = row.proposer;
        this.rSrecord.proposerNo = row.proposerNo;
        this.rSrecord.department = row.department;
      },
      getData() {
        this.$http
          .get("basic", `rSRecord/${this.rSrecord.pkid}`)
          .then(resp => {
            //console.log(resp);
            this.rSrecord = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "rSRecord", this.rSrecord)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
